var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareOutlinedLight = function SvgShareOutlinedLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shareOutlinedLight_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.408 13.481A2.6 2.6 0 0 0 7 12.923l5.059 2.45a2 2 0 0 0-.042.408c0 1.434 1.167 2.6 2.6 2.6s2.6-1.166 2.6-2.6c0-1.433-1.167-2.6-2.6-2.6a2.58 2.58 0 0 0-1.908.842l-4.842-2.342a2.5 2.5 0 0 0 .141-.8c0-.333-.066-.641-.183-.933l4.792-2.317a2.57 2.57 0 0 0 2 .959c1.433 0 2.6-1.167 2.6-2.6s-1.167-2.6-2.6-2.6a2.603 2.603 0 0 0-2.6 2.6c0 .091.017.166.025.258l-5.167 2.5A2.603 2.603 0 0 0 2.8 10.89c0 1.433 1.167 2.6 2.6 2.6zm9.209 1.025a1.266 1.266 0 1 1 0 2.533 1.266 1.266 0 0 1 0-2.533m0-9.8a1.266 1.266 0 1 1 0 2.533 1.266 1.266 0 0 1 0-2.533m-9.209 4.9a1.266 1.266 0 1 1 .002 2.533 1.266 1.266 0 0 1-.002-2.533"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shareOutlinedLight_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .89h20v20H0z"
  })))));
};
export default SvgShareOutlinedLight;